import React from 'react';

const BFMHeader = () => {
  return (
    <div className='bfm-header'>
      <div className='bfm-header-message'>
        <div>
          <p className='bfm-header-message-header'>BUY-FOR-ME SERVICE</p>
          <p className='bfm-header-message-text'>Tell us what items you’d like to buy and we’ll make your shopping experience easier.</p>
        </div>
      </div>
      <img src='https://cdn.shippingcart.com/assets/buy-for-me-image@2x-20220615011033.png' alt='buy-for-me' />
    </div>
  )
}

export default BFMHeader;


/** WEBPACK FOOTER **
 ** ./src/components/BuyForMe/BFMHeader.js
 **/